import { SelectProps } from 'antd/lib/select';
import { useEffect, useState, VFC } from 'react';
import { Col, Row } from 'antd';
import { Scanner } from '@yudiel/react-qr-scanner';
import { FormattedMessage } from 'react-intl';
import { Select } from '../Select/Select';
import { QeReader as messages } from './messages';

interface QrReaderProps {
  onScan: (data: string) => void;
}

export const QrReader: VFC<QrReaderProps> = ({ onScan }) => {
  const [videoInputOptions, setVideoInputOptions] = useState<Exclude<SelectProps['options'], undefined>>([]);
  const [deviceId, setDeviceId] = useState<string>('');

  useEffect(() => {
    if (navigator.mediaDevices) {
      navigator.mediaDevices.enumerateDevices().then(devices => {
        const videoInputs = devices.filter(device => device.kind === 'videoinput');
        setVideoInputOptions(
          Object.values(videoInputs).map(device => ({
            label: device.label,
            value: device.deviceId,
          })),
        );
      });
    }
  }, []);

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <Select
          className="w-100"
          options={videoInputOptions}
          placeholder={<FormattedMessage {...messages.selectCamera} />}
          onSelect={setDeviceId}
        />
      </Col>
      <Col span={24} style={{ height: 360 }}>
        <Scanner
          key={deviceId}
          allowMultiple={false}
          components={{ audio: false, finder: false }}
          constraints={deviceId ? { deviceId } : { facingMode: 'environment' }}
          formats={['qr_code', 'micro_qr_code']}
          onScan={result => {
            if (result) onScan(result[0].rawValue);
          }}
        />
      </Col>
    </Row>
  );
};
